var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leadership container-fluid"},[_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-12"},_vm._l((_vm.filteredTeaching),function(t){return _c('teach-card',{attrs:{"title":t.title,"year":t.year,"desc":t.desc,"tags":t.tags,"loc":t.location,"lesson":t.lesson,"type":"leadership"}})}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d4182b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Leadership.vue
// module id = null
// module chunks = 